
import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { BodyLayoutComponent } from '@reflact/ngx-layout';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DividerModule } from 'primeng/divider';
import { PopoverModule } from 'primeng/popover';
import { LoginService } from '@shared-angular/services/login.service';
import { ProjectService } from 'src/app/shared/services/project.service';
import { INavData } from 'src/app/shared/types/nav-data.types';
import { APP_VERSION } from 'src/version';
import { PageHeaderComponent } from "../../../shared/components/ai-bot/page-header/page-header.component";
import { SocketAdminService } from '@shared-angular/services/socketadmin.service';
import { handbookChannelForHostname, resolveHandbookUrl } from '@shared/documentation/handbook-url';
import { ProviderStatusComponent } from '../../../shared/components/ai-bot/provider-status/provider-status.component';

@Component({
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  imports: [RouterOutlet, RouterLink, BodyLayoutComponent,
    PopoverModule,
    DividerModule,
    BsDropdownModule,
    FormsModule,
    PageHeaderComponent,
    ProviderStatusComponent
  ]
})
export class BotAdminComponent implements OnInit {
  @ViewChild('projectNav', { static: true }) public projectNav!: TemplateRef<unknown>;
  @ViewChild('separator', { static: true }) public separator!: TemplateRef<unknown>;
  public navItems: INavData[] = [];
  public readonly APP_VERSION = APP_VERSION;

  constructor(
    public router: Router,
    public socketAdminService: SocketAdminService,
    private loginservice: LoginService,
    public projectService: ProjectService,
    public cdr: ChangeDetectorRef
  ) {
  }

  public get isProjectSection(): boolean {
    const path = (this.router.url.split(/[?#]/)[0] ?? '').replace(/\/$/, '');
    return path === '/bot-admin' || path.startsWith('/bot-admin/project/');
  }

  public logout(): void {
    void this.loginservice.logout(true);
  }

  public ngOnInit(): void {
    const navItems: INavData[] = [
      {
        template: this.projectNav
      },
      {
        name: $localize`:@@archive:Archiv`,
        url: "/bot-admin/archive",
        icon: 'ri-archive-line'
      },
      {
        name: $localize`:@@trashbin:Papierkorb`,
        url: "/bot-admin/trash",
        icon: 'ri-delete-bin-line'
      },
      // Only Logto sessions can ask the portal who still has access (#823).
      ...(this.loginservice.loginVia() === 'logto' ? [{
        name: $localize`:@@orphans-title:Verwaiste Nutzer`,
        url: "/bot-admin/orphans",
        icon: 'ri-user-unfollow-line'
      }] : []),
      {
        template: this.separator
      },
      {
        name: $localize`:@@documentation:Handbuch`,
        href: resolveHandbookUrl(
          "/handbuch",
          handbookChannelForHostname(window.location.hostname)
        ),
        icon: 'ri-book-open-line'
      }
    ];

    if (this.loginservice.hasSUPERAdmin()) {
      navItems.splice(4, 0, {
        name: $localize`:@@templates:Vorlagen verwalten`,
        url: "/bot-admin/templates",
        icon: 'ri-git-merge-line'
      });
    }

    this.navItems = navItems;

    // nicht blockierend: Menü soll nicht auf den Socket-Handshake warten
    void this.loginservice.setAdminPosition('home');
  }
}
